// components/ScrollingLogos.js
import { motion } from "framer-motion";

const schoolLogos2 = [
  { id: 1, src: "https://www.oncampus.global/themes/custom/oncampus/assets/img/logo.svg", alt: "oncampus" },
  { id: 2, src: "https://dspace-backend.independentcolleges.ie/server/api/core/bitstreams/114d832c-5516-403a-88f8-d92a713bd85f/content", alt: "independent colleges" },
  { id: 3, src: "https://enniskillenroyalgs.com/wp-content/uploads/2018/12/Loughborough-Univeristy-Lboro-Logo.png", alt: "Loughborough University" },
  { id: 4, src: "https://tukuz.com/wp-content/uploads/2020/12/istituto-marangoni-logo-vector.png", alt: "Istituto Marangoni Milan" },
  { id: 5, src: "https://upload.wikimedia.org/wikipedia/commons/b/bb/Paris_School_of_Business_%28PSB%29_logo.svg", alt: "paris school of business" },
  { id: 6, src: "https://www.graduatesfirst.com/wp-content/uploads/2024/11/University-of-Hull.png", alt: "University of Hull" },
  { id: 7, src: "https://a.storyblok.com/f/91079/4000x2000/3b71741821/aston-university-logo.png", alt: "Aston University" },
  { id: 8, src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwvbmKnxFogytHXpKVjPrIlpRPXqcI7qTE_Q&s", alt: "maynooth university" },
  { id: 9, src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXjr1oBTAyuKIfodt3Q5kIxmkxL1oBvaoUUg&s", alt: "dublin city University" },
  { id: 10, src: "https://www.gstudyabroad.com/wp-content/uploads/2018/07/1200px-University_of_Sunderland_logo.svg_-300x140.png", alt: "University of Sunderland" },
];
const schoolLogos = [
  { id: 1, src: "https://www.intoglobal.com/images/into-logo.png", alt: "into global" },
  { id: 2, src: "https://www.nicepng.com/png/full/844-8447892_drew-rangers-logo-png-transparent-drew-university-athletics.png", alt: "drew University" },
  { id: 3, src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmDjtaWOVEj1bMDZfmjeiXCn6ppOFG2IyUDA&s", alt: "University of Stirling" },
  { id: 4, src: "https://cdn.worldvectorlogo.com/logos/illinois-state-university.svg", alt: "illinois state university" },
  { id: 5, src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4YzGhOSf_ZTyul5QnO8EBzr3QUebQb52BiA&s", alt: "The University of Manchester" },
  { id: 6, src: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/George_Mason_University_logo.svg/1024px-George_Mason_University_logo.svg.png", alt: "George Mason University" },
  { id: 7, src: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Hofstra_University_logo_stacked.svg/2560px-Hofstra_University_logo_stacked.svg.png", alt: "Hofstra University" },
  { id: 8, src: "https://1000logos.net/wp-content/uploads/2017/07/Logo-University-of-Arizona.jpg", alt: "University-of-Arizona" },
  { id: 9, src: "https://brand.colostate.edu/wp-content/uploads/sites/47/2019/02/CSU-Signature-C-357-617.png", alt: "Colorado State University" },
  { id: 10, src: "https://docs.gato.txst.edu/42768/w/2000/r1N5vd4QqcgI/Round%20Rock_CMYK_3_color_H.png", alt: "Texas State University" },
];

const ScrollingLogos = () => {
  return (
    <div className="relative bg-white schoolBg overflow-hidden py-8 mt-12">
      <div className="relative flex flex-col gap-16 overflow-x-hidden h-full md:min-h-64">
        {/* First Row */}
        <div className="flex">
          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: 0 }}
            animate={{ x: "-100%" }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          >
            {schoolLogos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-40 h-12 sm:h-20 shadow-2xl mr-8 rounded-xl bg-white p-3"
              />
            ))}
          </motion.div>

          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: 0 }}
            animate={{ x: "-100%" }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          >
            {schoolLogos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-40 h-12 sm:h-20 shadow-2xl mr-8 rounded-xl bg-white p-3"
              />
            ))}
          </motion.div>
        </div>

        {/* Second Row (Opposite Direction) */}
        {/* <motion.div
          className="absolute top-16 flex space-x-4 sm:space-x-8 animate-scroll mt-16"
          initial={{ x: "-100%" }}
          animate={{ x: "100%" }}
          transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
        >
          {schoolLogos.map((logo) => (
            <img
              key={logo.id}
              src={logo.src}
              alt={logo.alt}
              className="w-24 sm:w-40 h-12 sm:h-20 shadow-2xl rounded-xl bg-white p-3"
            />
          ))}
        </motion.div> */}
        <div className="flex">
          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          >
            {schoolLogos2.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-40 h-12 sm:h-20 shadow-2xl mr-8 rounded-xl bg-white p-3"
              />
            ))}
          </motion.div>

          <motion.div
            className="flex flex-wrap flex-shrink-0 animate-scroll"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          >
            {schoolLogos2.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="w-24 sm:w-40 h-12 sm:h-20 shadow-2xl mr-8 rounded-xl bg-white p-3"
              />
            ))}
          </motion.div>
        </div>
      </div>
      <div className="mt-8 text-center">
        <a
          href="/application"
          className="mt-12 uppercase text-white bg-secondary w-40 py-3 px-8 rounded-full hover:bg-gray-cool duration-300"
        >
          schedule a free consultation
        </a>
      </div>
    </div>
  );
};

export default ScrollingLogos;
